import { PayloadAction } from "@reduxjs/toolkit";
import { ItemId } from "../../../../common/models/ItemId";
import { EmployeesState } from "../models/EmployeesState";

const setNewItemId = (state: EmployeesState, action: PayloadAction<ItemId>) => {
    state.newItemId = action.payload.id;
}

export default setNewItemId;